import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export function Artifact({ className, ...props }: HTMLAttributes<HTMLElement>) {
	return (
		<figure
			className={cn("overflow-hidden rounded-xl border border-border bg-card shadow-sm", className)}
			{...props}
		/>
	);
}

export function ArtifactContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	return <div className={cn("overflow-hidden", className)} {...props} />;
}

export function ArtifactHeader({ className, ...props }: HTMLAttributes<HTMLElement>) {
	return (
		<figcaption
			className={cn(
				"flex min-w-0 items-center gap-3 border-hairline-strong border-t px-4 py-3",
				className,
			)}
			{...props}
		/>
	);
}

export function ArtifactTitle({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
	return <p className={cn("truncate font-medium text-sm", className)} {...props} />;
}

export function ArtifactDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
	return <p className={cn("truncate text-muted-foreground text-xs", className)} {...props} />;
}

export function ArtifactActions({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	return <div className={cn("ml-auto flex shrink-0 items-center gap-2", className)} {...props} />;
}
